import { render, staticRenderFns } from "./MyCollectionLists.vue?vue&type=template&id=705dfbba&"
import script from "./MyCollectionLists.vue?vue&type=script&lang=js&"
export * from "./MyCollectionLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports